import { styled } from "@mui/material/styles";
import { 
    Menu, 
    Box, 
    ListItem 
} from "@mui/material";

// Styled components for desktop menu
export const StyledMenu = styled(Menu)(({ }) => ({
    '& .MuiPaper-root': {
        width: 292,
        maxWidth: '100%',
        marginTop: '8px',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        padding: '20px'
    },
    '& .MuiList-root': {
        padding: 0,
        display: 'flex',
        gap: '16px',
        flexDirection: 'column'
    },
    '& .MuiMenuItem-root': {
        padding: '6px',
        minHeight: '40px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        color: '#000000',
        fontSize: '16px',
        fontWeight: 400,
        '&:hover': {
            backgroundColor: '#f8f8f8',
        },
        '&.active': {
            backgroundColor: '#ffffff',
            color: '#ff0066',
        },
        '&.submenu-item': {
            paddingLeft: '48px',
            backgroundColor: '#f8f8f8',
            minHeight: '36px',
            color: '#666666',
        }
    },
    '& .MuiDivider-root': {
        margin: '0 16px',
        borderColor: '#f0f0f0',
        width: '90%'
    },
    // Estilos específicos para los íconos y el texto
    '& .menu-icon': {
        width: '15px',
        height: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Estilos para Cerrar sesión
    '& .logout-item': {
        color: '#000000',
        backgroundColor: '#F3F3F3',
        padding: '16px 34px',
        display: 'flex',
        alignItems: 'center',
        marginTop: '-16px',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        height: '50px',
        margin: '0 -24px -20px',
        width: 'calc(100% + 48px)',
        position: 'relative',
        '& .menu-icon': {
            opacity: 0.7
        }
    }
}));

// Mobile Menu Styles
export const MobileMenuContainer = styled(Box)(({ }) => ({
    width: '100%',
    height: '100vh',
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    overflow: 'auto'
}));

export const MenuHeader = styled(Box)(({ }) => ({
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #EEEEEE'
}));

export const MobileMenuItem = styled(ListItem)(({ }) => ({
    padding: '6px 24px',
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#000000',
    fontSize: '16px',
    fontWeight: 400,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#f8f8f8',
    },
    '&.active': {
        backgroundColor: '#ffffff',
        color: '#ff0066',
    },
    '&.logout-item': {
        color: '#000000',
        backgroundColor: '#F3F3F3',
        padding: '16px 34px',
        display: 'flex',
        alignItems: 'center',
        marginTop: '-16px',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        height: '50px',
        margin: '0 -24px -20px',
        width: 'calc(100% + 48px)',
        position: 'relative',
        '& .menu-icon': {
            opacity: 0.7
        },
    }
}));

export const MobileSubMenuItem = styled(ListItem)(({ }) => ({
    padding: '12px 24px 12px 56px',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#f8f8f8',
    }
}));